import {Controller} from '@hotwired/stimulus';

/**
 * Met en chargement (`button.md` › loading) le bouton d'envoi d'un formulaire qui quitte la page, et ignore tout
 * envoi suivant : un double clic ne refait pas partir l'action.
 *
 *   <form method="post" action="…" {{ stimulus_controller('submit-loading')
 *         |stimulus_action('submit-loading', 'submit', 'submit') }}>
 *     <button type="submit" class="btn btn-primary">{{ lucide('send', {size: 16}) }}…</button>
 *   </form>
 *
 * Le spinner remplace l'icône du bouton (`.btn.is-loading > i`), qui prend `aria-disabled="true"` et reste
 * focusable. Un envoi déjà annulé par un écouteur placé avant (`submit-confirm`) ne met rien en chargement. La page
 * rendue par le cache du navigateur (retour arrière) retrouve son bouton actif.
 */
export default class extends Controller {
  connect() {
    this.reset = this.reset.bind(this);
    window.addEventListener('pageshow', this.reset);
  }

  disconnect() {
    window.removeEventListener('pageshow', this.reset);
  }

  submit(event) {
    if (this.submitting) {
      event.preventDefault();

      return;
    }

    if (event.defaultPrevented) {
      return;
    }

    this.submitting = true;
    this.button = event.submitter ?? this.element.querySelector('[type="submit"]');
    this.button?.classList.add('is-loading');
    this.button?.setAttribute('aria-disabled', 'true');
  }

  reset(event) {
    if (!event.persisted || !this.submitting) {
      return;
    }

    this.submitting = false;
    this.button?.classList.remove('is-loading');
    this.button?.removeAttribute('aria-disabled');
    this.button = null;
  }
}
